var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8173 17.5409L16.3758 14.9112C16.1045 14.619 15.6475 14.6019 15.3553 14.8732L14.4067 15.7543C14.3401 15.6166 14.2593 15.4821 14.1599 15.3553C14.1599 15.3553 11.9005 13.0705 11.2466 12.2316C10.5924 11.3926 8.92481 8.64574 8.92481 8.64574C8.87912 8.58717 8.83085 8.53215 8.78097 8.47969C8.93189 8.49256 9.08732 8.46038 9.22505 8.37382L10.343 7.67004C10.6802 7.45766 10.7816 7.01196 10.5692 6.6744L8.65708 3.63757C8.44469 3.30033 7.99932 3.19896 7.66207 3.41135L6.54382 4.11512C6.45468 4.17144 6.38292 4.24449 6.32821 4.32719L5.86868 4.66057C5.00787 5.28454 4.9094 6.13956 5.27174 7.32089C5.27174 7.32089 6.1184 9.92264 8.47172 13.168C10.7298 16.2814 12.564 18.2621 14.2944 19.5567C15.3038 20.3126 16.1222 20.6093 16.9827 19.985L17.4647 19.6355C17.5902 19.6101 17.7109 19.5535 17.8113 19.4598L18.7793 18.561C19.0718 18.2898 19.0885 17.8331 18.8173 17.5409Z",
    fill: "#2B9FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.9865 9.96807C20.7088 4.42442 16.1115 0 10.5003 0C4.7105 0 0 4.71018 0 10.5C0 16.2898 4.7105 21 10.5003 21C10.8556 21 11.1439 20.7117 11.1439 20.3564C11.1439 20.0011 10.8556 19.7128 10.5003 19.7128C5.42039 19.7128 1.2872 15.5799 1.2872 10.5C1.2872 5.42007 5.42039 1.2872 10.5003 1.2872C15.401 1.2872 19.419 5.13431 19.6961 9.9671L17.6333 9.96549L20.3538 13.0342L23.0798 9.96935L20.9865 9.96807Z",
    fill: "#2B9FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBack);
export default __webpack_public_path__ + "static/media/callBack.4e59b8800abac8327bb4f08618d0ae5d.svg";
export { ForwardRef as ReactComponent };